// @ts-nocheck
(() => {
  if (window.initBackdropCursor) {
    return;
  }

  const CURSOR_CLASS = 'backdrop-cursor';
  const ROOT_ACTIVE_CLASS = 'has-backdrop-cursor-active';
  const DOC_ACTIVE_CLASS = 'has-backdrop-cursor-active';

  const CROSS_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';

  /**
   * @param {object} options
   * @param {HTMLElement} options.root
   * @param {HTMLElement} [options.contentRoot]
   * @param {() => boolean} options.isEnabled
   * @returns {{ hide: () => void, destroy: () => void }}
   */
  function initBackdropCursor({ root, contentRoot, isEnabled }) {
    const isDialogMode = Boolean(contentRoot);
    const indicator = document.createElement('span');
    indicator.className = CURSOR_CLASS;
    if (isDialogMode) {
      indicator.classList.add(`${CURSOR_CLASS}--dialog`);
    }
    indicator.setAttribute('aria-hidden', 'true');
    indicator.hidden = true;
    indicator.innerHTML = CROSS_SVG;

    const sheetHost = root.closest('sheet-content');
    // Native <dialog> + ::backdrop render in the top layer above body nodes.
    // Mount inside the dialog so the cross paints above the backdrop.
    const mountTarget = isDialogMode ? root : (sheetHost ?? document.body);
    mountTarget.appendChild(indicator);

    /**
     * @param {PointerEvent} event
     * @returns {boolean}
     */
    const shouldShow = (event) => {
      if (!isEnabled()) {
        return false;
      }

      if (contentRoot) {
        const hit = document.elementFromPoint(event.clientX, event.clientY);
        if (!hit) {
          return false;
        }

        if (contentRoot.contains(hit)) {
          return false;
        }

        // Inside dialog chrome (e.g. auto-injected close) but not on ::backdrop.
        if (root.contains(hit) && hit !== root) {
          return false;
        }

        // Backdrop: native dialog receives hits on itself, or the page below.
        return hit === root || !root.contains(hit);
      }

      return event.target === root;
    };

    /**
     * @param {PointerEvent} event
     */
    const updatePosition = (event) => {
      if (isDialogMode) {
        const rect = root.getBoundingClientRect();
        indicator.style.left = `${event.clientX - rect.left}px`;
        indicator.style.top = `${event.clientY - rect.top}px`;
        return;
      }

      indicator.style.left = `${event.clientX}px`;
      indicator.style.top = `${event.clientY}px`;
    };

    const hide = () => {
      indicator.hidden = true;
      root.classList.remove(ROOT_ACTIVE_CLASS);
      document.documentElement.classList.remove(DOC_ACTIVE_CLASS);

      if (sheetHost) {
        sheetHost.classList.remove(ROOT_ACTIVE_CLASS);
      }
    };

    /**
     * @param {PointerEvent} event
     */
    const show = (event) => {
      indicator.hidden = false;
      root.classList.add(ROOT_ACTIVE_CLASS);
      document.documentElement.classList.add(DOC_ACTIVE_CLASS);

      if (sheetHost) {
        sheetHost.classList.add(ROOT_ACTIVE_CLASS);
      }

      updatePosition(event);
    };

    /**
     * @param {PointerEvent} event
     */
    const onPointerMove = (event) => {
      if (shouldShow(event)) {
        show(event);
        return;
      }

      hide();
    };

    const onPointerLeave = () => {
      hide();
    };

    root.addEventListener('pointermove', onPointerMove);
    root.addEventListener('pointerleave', onPointerLeave);

    if (contentRoot) {
      document.addEventListener('pointermove', onPointerMove);
    }

    return {
      hide,
      destroy() {
        hide();
        root.removeEventListener('pointermove', onPointerMove);
        root.removeEventListener('pointerleave', onPointerLeave);

        if (contentRoot) {
          document.removeEventListener('pointermove', onPointerMove);
        }

        indicator.remove();
      },
    };
  }

  window.initBackdropCursor = initBackdropCursor;
})();
